import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import type { Breadcrumb } from '@/types/shared'
import { Form } from './components/Form'

type PrefectureOption = {
  code: number
  name: string
}

type AdminTeamNewProps = {
  team: {
    id?: string
    name: string | null
    prefectureId: number | null
  }
  options: {
    prefectures: PrefectureOption[]
  }
  breadcrumbs: Breadcrumb[]
}

export default function New({ team, options, breadcrumbs }: AdminTeamNewProps) {
  return (
    <AppShell>
      <Head title="新規チーム作成" />
      <PageHeader
        title="新規チーム作成"
        description="新しいチームを登録します。"
        breadcrumbs={breadcrumbs}
      />
      <Form values={team} prefectures={options.prefectures} mode="create" />
    </AppShell>
  )
}
